<template>
    <Head :title="seo?.title || title">
        <meta v-if="seo?.description" head-key="description" name="description" :content="seo.description" />
        <meta v-if="seo?.robots" head-key="robots" name="robots" :content="seo.robots" />
        <link v-if="seo?.canonical" head-key="canonical" rel="canonical" :href="seo.canonical" />

        <meta v-if="seo?.title" head-key="og:title" property="og:title" :content="seo.title" />
        <meta v-if="seo?.description" head-key="og:description" property="og:description" :content="seo.description" />
        <meta head-key="og:type" property="og:type" :content="seo?.ogType || 'website'" />
        <meta v-if="seo?.canonical" head-key="og:url" property="og:url" :content="seo.canonical" />
        <meta v-if="seo?.ogImage" head-key="og:image" property="og:image" :content="seo.ogImage" />
        <meta v-if="seo?.ogImageAlt" head-key="og:image:alt" property="og:image:alt" :content="seo.ogImageAlt" />
        <meta head-key="og:locale" property="og:locale" content="ru_RU" />
        <meta head-key="og:site_name" property="og:site_name" :content="brand" />

        <meta head-key="twitter:card" name="twitter:card" content="summary_large_image" />
        <meta v-if="seo?.title" head-key="twitter:title" name="twitter:title" :content="seo.title" />
        <meta v-if="seo?.description" head-key="twitter:description" name="twitter:description" :content="seo.description" />
        <meta v-if="seo?.ogImage" head-key="twitter:image" name="twitter:image" :content="seo.ogImage" />

        <component
            :is="'script'"
            v-for="(block, index) in seo?.jsonLd || []"
            :key="'jsonld-' + index"
            type="application/ld+json"
            v-html="JSON.stringify(block)"
        />

        <slot />
    </Head>
</template>

<script setup>
import { Head, usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

const props = defineProps({
    title: {
        type: String,
        default: null,
    },
    seo: {
        type: Object,
        default: null,
    },
});

const page = usePage();
const seo = computed(() => props.seo || page.props.seo || null);
const brand = computed(() => page.props.seoBrand || 'Волейбол Беларуси');
</script>
